var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignRouteNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.501953,
    y: 0.5,
    width: 24.9985,
    height: 25.0009,
    rx: 2.5,
    stroke: "#8893A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7592 12.7228H7.7606C8.00198 12.7228 8.22611 12.605 8.35025 12.412C8.713 11.8527 10.5192 8.99202 10.5192 7.57425C10.5192 6.15456 9.28197 5 7.76056 5C6.23916 5 5.00195 6.15456 5.00195 7.57425C5.00195 8.95726 6.80677 11.845 7.16884 12.4093C7.29298 12.6031 7.51642 12.7221 7.7592 12.7228Z",
    fill: "#8893A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.242 13.2773C16.7206 13.2773 15.4834 14.4319 15.4834 15.8516C15.4834 17.2346 17.2882 20.1223 17.6503 20.6867C17.7744 20.8804 17.9979 20.9995 18.2406 21.0001H18.242C18.4834 21.0001 18.7075 20.8823 18.8317 20.6892C19.1944 20.13 21.0006 17.2694 21.0006 15.8516C21.0006 14.4319 19.7633 13.2773 18.242 13.2773Z",
    fill: "#8893A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75841 15.2959H10.1722C11.1232 15.2959 11.8964 14.5739 11.8964 13.6871C11.8964 13.5094 12.0515 13.3652 12.2412 13.3652H14.655C15.7956 13.3652 16.7239 12.499 16.7239 11.4345C16.7239 10.3702 15.7956 9.50391 14.655 9.50391H11.8964C11.515 9.50391 11.2067 9.79218 11.2067 10.1474C11.2067 10.5027 11.515 10.791 11.8964 10.791H14.655C15.0356 10.791 15.3446 11.08 15.3446 11.4345C15.3446 11.7892 15.0356 12.0781 14.655 12.0781H12.2412C11.2902 12.0781 10.5171 12.8002 10.5171 13.687C10.5171 13.8647 10.3619 14.0088 10.1722 14.0088H7.75841C6.61773 14.0088 5.68945 14.8751 5.68945 15.9395C5.68945 17.004 6.61773 17.8703 7.75841 17.8703H13.9653C14.3467 17.8703 14.655 17.5819 14.655 17.2267C14.655 16.8714 14.3467 16.5831 13.9653 16.5831H7.75841C7.37773 16.5831 7.06877 16.2941 7.06877 15.9395C7.06877 15.585 7.37773 15.2959 7.75841 15.2959Z",
    fill: "#8893A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignRouteNew);
export default __webpack_public_path__ + "static/media/assignRouteNew.29a0d979be032893c5c0e671a9d8a244.svg";
export { ForwardRef as ReactComponent };